import React, {useEffect, useState, useCallback} from 'react';
import Helmet from 'react-helmet';
import {ColumnW50Div} from './../../common/Layouts/Layouts';
import {ReviewByUserWrapperDiv, UserReviewOuterWrapperDiv, FlexContainerWrap} from './RnR.styles';

//Selectors
import {hotelsPartnerFn} from '@stencil/hotels-common-reducer/src/selectors';
import {
  detailUrlFromStaticDataSelector,
  hotelIdSelectorFnFromDetails,
} from '@stencil/hotels-details-reducer/src/selectors';
//Configs
import {apiConfig} from '@stencil/hotels-config';
import {scrollToEl} from '@stencil/hotels-utils/src/scroll-into-view-details';

import {detailsNavigationIdsAndValues} from '@stencil/hotels-utils/src/get-details-navigation-id-and-values';

import GuestReview from './../GuestReview/GuestReview';
import WhatToKnow from './../WhatToKnow/WhatToKnow';
import UserReview from './../UserReview/UserReview';
import Pagination from './../Pagination/Pagination';

import {shallowEqual, useDispatch, useSelector} from 'react-redux';

//GA Events
import {pushga} from 'ga-utils';
import {gaConfig} from '@stencil/hotels-config';
const {DetailPageGAEvents} = gaConfig;

interface IItemsChange {
  offset: number;
  limit: number;
}

import {fetchUserReviews} from '@stencil/hotels-ugc-redux/src/hotels-ugc-thunks';
import {
  reviewDataSelector,
  rnrPaginatorStatus,
  hasReviewDataSelector,
  reviewDetailTypeSelector,
  giSnapData,
} from '@stencil/hotels-ugc-redux/src/hotels-ugc-selectors';

const RnR = () => {
  const reviewData = useSelector(reviewDataSelector, shallowEqual);
  const paginatorStatus = useSelector(rnrPaginatorStatus, shallowEqual);
  const hasReviewData = useSelector(hasReviewDataSelector, shallowEqual);
  const hotelId = useSelector(hotelIdSelectorFnFromDetails);
  const reviewDetailType = useSelector(reviewDetailTypeSelector, shallowEqual);
  const snapData = useSelector(giSnapData, shallowEqual) || {};

  const {tagIds, filter, sortBy, page} = reviewDetailType;
  const {reviewsCount = 0, reviews = [], tagData = []} = reviewData;

  const [totalCount, updateTotalCount] = useState(reviewsCount || 0);
  const [paginationStatus, updatePaginationStatus] = useState(paginatorStatus || ['default']);

  const hotelUrl = useSelector(detailUrlFromStaticDataSelector);
  const partner = useSelector(hotelsPartnerFn);

  useEffect(() => {
    updateTotalCount(reviewsCount);
  }, [reviewData.reviewsCount]);

  useEffect(() => {
    updatePaginationStatus(paginatorStatus);
  }, [paginatorStatus]);

  const dispatch = useDispatch();

  const updateReviewData = useCallback(
    (vid, off, lim, tags, fil, sort) => {
      return dispatch(fetchUserReviews(vid, off, lim, tags, fil, sort));
    },
    [reviewData],
  );

  const onChangePage = ({offset, limit}: IItemsChange) => {
    updateReviewData(hotelId, offset, limit, tagIds, filter, sortBy);
    //scroll to first review
    scrollToEl(detailsNavigationIdsAndValues.guestReviews.id);
  };

  const pushPaginationGA = pageNumber => {
    pushga({
      eventCategory: DetailPageGAEvents.reviewConsumptionCategory,
      eventAction: DetailPageGAEvents.paginationClicked,
      eventLabel: `${pageNumber} number clicked`,
    });
  };

  const getPageVolume = pageNumber => {
    let pageVolume = pageNumber === 1 ? 5 : 25;
    return pageVolume;
  };

  const makeUrl = page => {
    if (page > 1 && page <= totalCount) {
      return `${apiConfig.__GOIBIBO__}/${partner}/${hotelUrl}/?page=${page}`;
    } else {
      return `${apiConfig.__GOIBIBO__}/${partner}/${hotelUrl}/`;
    }
  };

  return (
    <>
      <ReviewByUserWrapperDiv>
        <Helmet>
          {page > 1 && <link rel="prev" href={makeUrl(page - 1)} />}
          {page < totalCount && <link rel="next" href={makeUrl(page + 1)} />}
        </Helmet>
        <FlexContainerWrap>
          <GuestReview snapData={snapData} />
        </FlexContainerWrap>
        <FlexContainerWrap>{tagData.length > 0 && <WhatToKnow />}</FlexContainerWrap>
      </ReviewByUserWrapperDiv>
      <UserReviewOuterWrapperDiv>
        {reviews.length > 0 && reviews.map((item, i) => <UserReview review={item} key={item.id} />)}
      </UserReviewOuterWrapperDiv>
      {hasReviewData && (
        <Pagination
          onChangePage={onChangePage}
          initialPage={page || 1}
          getPageSize={getPageVolume}
          totalNumberOfItems={totalCount}
          status={paginationStatus}
          initCall={false}
          maxPages={6}
          pushPaginationGA={pushPaginationGA}
          linkable={true}
          makeUrl={makeUrl}
        />
      )}
    </>
  );
};

export default RnR;
